/**
* @author Ryan Gladstone
*/

function utilityService($window) {
  const service = {};

  service.unauthRedirect = () => {
    $window.location.reload();
  };

  service.clearWebSkedLocalStorage = () => {
    for (let i = 0; i < localStorage.length - 1; i += 1) {
      const key = localStorage.key(i);

      if (/^arc\.websked\./.test(key)) {
        localStorage.removeItem(key);
      }
    }
  };

  service.millisecondsToSeconds = mil => Math.floor(mil / 1000);

  service.secondsToMilliseconds = sec => Math.floor(sec * 1000);

  return service;
}

const arr = [
  '$window',
  utilityService
];

module.exports = (ngModule) => {
  ngModule.service('utilityService', arr);
};
